import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import ToolbarBackIcon from '../Icons/ToolbarBackIcon.js';

function Toolbar(_a) {
    var { actions, back, buttons, className, onBack, title } = _a, others = __rest(_a, ["actions", "back", "buttons", "className", "onBack", "title"]);
    return (jsxs("div", Object.assign({ className: cns('toolbar', className) }, others, { children: [back && (jsx("div", { className: "toolbar__backBtn", onClick: onBack, role: "presentation", children: jsx(ToolbarBackIcon, { className: "toolbar__backIcon" }) })), jsx("div", { className: "toolbar__title", children: jsx("span", { children: title }) }), jsx("div", { className: "toolbar__actions", children: actions }), jsx("div", { className: "toolbar__buttons", children: buttons })] })));
}
Toolbar.defaultProps = {
    actions: null,
    back: false,
    buttons: null,
    className: '',
    onBack: null,
    title: '',
};

export { Toolbar as default };
